import React from 'react';

const PaginationControls = ({ itemsPerPage, totalItems, paginate, currentPage }) => {

  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <nav className={`${pageNumbers.length === 0 ? 'hidden' : 'flex justify-center mt-4'}`} >
      <ul className="flex items-center space-x-2">
        {/* Previous Button */}
        <li>
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className={`px-3 py-1 border border-gray-300 rounded ${currentPage === 1 ? 'bg-gray-200 text-black cursor-not-allowed' : 'bg-white text-black hover:bg-blue-100'}`}
          >
            &laquo;
          </button>
        </li>
        
        {/* Page Numbers */}
        {pageNumbers.map(number => (
          <li key={number}>
            <button
              onClick={() => paginate(number)}
              className={`px-3 py-1 border border-gray-300 cursor-pointer rounded ${currentPage === number ? 'bg-[#F2A549] text-white' : 'bg-white text-black hover:bg-blue-100'}`}
            >
              {number}
            </button>
          </li>
        ))}
        
        {/* Next Button */}
        <li>
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === pageNumbers.length}
            className={`px-3 py-1 border border-gray-300 rounded ${currentPage === pageNumbers.length || pageNumbers.length === 0 ? 'bg-gray-200 text-black cursor-not-allowed' : 'bg-white text-black hover:bg-blue-100'}`}
          >
            &raquo;
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default PaginationControls;
